import { format } from 'date-fns';

import { DBName, DBStores, DBVersion, exportStore } from './db';

export enum SessionEventTypes {
  'SessionStart' = 'SessionStart',
  'VideoPlay' = 'VideoPlay',
  'VideoPause' = 'VideoPause',
  'SessionEnd' = 'SessionEnd',
  'MQTTConnectionAttepmt' = 'MQTTConnectionAttepmt',
  'MQTTConnectionSuccess' = 'MQTTConnectionSuccess',
  'MQTTConnectionLost' = 'MQTTConnectionLost',
  'MQTTConnectionReconnectAttempt' = 'MQTTConnectionReconnectAttempt',
  'MQTTSubscribe' = 'MQTTSubscribe',
  'MQTTUnSubscribe' = 'MQTTUnSubscribe',
  'POLLReceivedMQTT' = 'POLLReceivedMQTT',
  'ActivePOLLRequest' = 'ActivePOLLRequest',
  'ActivePOLLResponse' = 'ActivePOLLResponse',
  'VideoLoading' = 'VideoLoading',
  'VideoBufferingStart' = 'VideoBufferingStart',
  'VideoBufferingEnd' = 'VideoBufferingEnd',
  'SidebarOpened' = 'SidebarOpened',
  'SidebarClosed' = 'SidebarClosed',
  'SocketConnectionAttepmt' = 'SocketConnectionAttepmt',
  'SocketConnectionSuccess' = 'SocketConnectionSuccess',
  'SocketConnectionFailure' = 'SocketConnectionFailure',
  'SocketConnectionLost' = 'SocketConnectionLost',
  'SocketConnectionReconnect' = 'SocketConnectionReconnect',
  'SocketConnectionReconnectAttempt' = 'SocketConnectionReconnectAttempt',
  'MQTTConnectionFailure' = 'MQTTConnectionFailure',
  'MQTTConnectionReconnect' = 'MQTTConnectionReconnect',
}

export interface ISessionEventData {
  timestamp: Date | string;
  description: string;
  videoDuration: number;
  videoState: 'playing' | 'paused' | 'buffering' | null;
  data: any;
}

export interface ISessionEvent {
  type: SessionEventTypes;
  data: ISessionEventData;
}

export class SessionEvent {
  static record = (data: ISessionEvent) => {
    console.info(data.type, data);
    if (data?.data?.videoDuration) {
      data.data.videoDuration = parseInt(data?.data?.videoDuration + '');
    }
    const request = indexedDB.open(DBName, DBVersion);

    request.onsuccess = () => {
      console.log('request.onsuccess - addData', data);
      const db = request.result;
      const tx = db.transaction(DBStores.Sessions, 'readwrite');
      const store = tx.objectStore(DBStores.Sessions);
      store.add({ id: new Date().getTime(), value: { ...data } });
    };

    // // @ts-ignore
    // let event = window.SESSION_EVENTS || [];
    // if(data.type === ISessionEventType.SessionStart && event?.length){
    //     event = [];
    // }
    // event.push(data);
    // // @ts-ignore
    // window.SESSION_EVENTS = event;
    // if(data.type === ISessionEventType.SessionEnd){
    //     // this.downloadStackTrace();
    // }
  };
  static reset = () => {
    const request = indexedDB.open(DBName, DBVersion);
    request.onsuccess = () => {
      const db = request.result;
      const tx = db.transaction(DBStores.Sessions, 'readwrite');
      const store = tx.objectStore(DBStores.Sessions);
      store.clear();
    };
  };
  static stackTrace = () => {
    // @ts-ignore
    return window.SESSION_EVENTS || [];
  };
  static downloadStackTrace = async () => {
    const data: any[] = await exportStore();
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `(${format(new Date(data[0]?.value?.data?.timestamp), 'dd-MM-yyyy hh:mm:ss')}) - (${format(new Date(data[data.length - 1]?.value?.data?.timestamp), 'dd-MM-yyyy hh:mm:ss')})-data.json`;
    link.click();
  };
}
